export default "__VITE_ASSET__53073894__"